/**
 * SPOTD — TRACKING CLIENT
 * Capture UTM params, persiste en localStorage, envoie au backend.
 */

const SESSION_KEY = 'spotd_session_id';
const UTM_KEY     = 'spotd_utm';
const API_URL     = process.env.REACT_APP_API_URL || 'http://localhost:3001';

function getSessionId() {
  let sid = localStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = 'sess_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

function extractUTM() {
  const params = new URLSearchParams(window.location.search);
  const utm = {
    source:   params.get('utm_source'),
    medium:   params.get('utm_medium'),
    campaign: params.get('utm_campaign'),
    content:  params.get('utm_content'),
    term:     params.get('utm_term'),
  };
  return Object.values(utm).some(Boolean) ? utm : null;
}

function getDevice() {
  const ua = navigator.userAgent;
  if (/tablet|ipad/i.test(ua)) return 'tablet';
  if (/mobile|android|iphone/i.test(ua)) return 'mobile';
  return 'desktop';
}

export function initTracking() {
  const sessionId = getSessionId();
  const utm = extractUTM();

  if (utm) {
    localStorage.setItem(UTM_KEY, JSON.stringify({
      ...utm,
      landing:     window.location.pathname,
      referrer:    document.referrer || null,
      captured_at: new Date().toISOString(),
    }));
  }

  const stored = JSON.parse(localStorage.getItem(UTM_KEY) || '{}');

  fetch(`${API_URL}/api/tracking/visit`, {
    method:  'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({
      session_id: sessionId,
      source:     stored.source   || 'direct',
      medium:     stored.medium   || 'organic',
      campaign:   stored.campaign || null,
      content:    stored.content  || null,
      term:       stored.term     || null,
      landing:    stored.landing  || window.location.pathname,
      referrer:   stored.referrer || document.referrer || null,
      device:     getDevice(),
    }),
  }).catch(() => {});
}

export async function trackConversion(userId) {
  const sessionId = getSessionId();
  try {
    await fetch(`${API_URL}/api/tracking/convert`, {
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ session_id: sessionId, user_id: userId }),
    });
    localStorage.removeItem(UTM_KEY);
  } catch {}
}

export { getSessionId };
